__turbopack_context__.v({
  "button": "inputWithButton-module__oPH7QW__button",
  "inputWithbutton": "inputWithButton-module__oPH7QW__inputWithbutton",
});
